import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  Business: [],
  AllBusiness: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};
export const fetchBusiness = createAsyncThunk("/Business", async id => {
  const response = await axiosInstanceAuth.get(`/Business/getBusiness?BusinessId=${id}`);

  return response.data;
});
export const fetchAllBusiness = createAsyncThunk("/AllBusiness", async () => {
  const response = await axiosInstanceAuth.get(`/Business/getAllBusiness`);

  return response.data;
});

const Businesslice = createSlice({
  name: "Business",
  initialState,
  reducers: {
    BusinessAdded: {
      reducer(state, action) {
        state.Business?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchBusiness.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchBusiness.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Business = action.payload.Data;
      })
      .addCase(fetchBusiness.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchAllBusiness.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchAllBusiness.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.AllBusiness = action.payload.Data;
      })
      .addCase(fetchAllBusiness.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getBusinessDetails = state => state.Business;

export const { BusinessAdded } = Businesslice.actions;

export default Businesslice.reducer;
